import React, { useState } from "react";
import { Link } from "react-router-dom";
import API_BASE from "../config"; 

const RequestAccess = () => {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        orgAdminEmail: ""
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
        const res = await fetch(`${API_BASE}/request-access`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(form)
        });

        const data = await res.json();

        if (!res.ok) {
            setError(data.error || "Failed to submit request.");
            return;
        }

        setSubmitted(true);
        } catch (err) {
        setError("Something went wrong. Please try again.");
        }
    };

    const containerStyle = {
        padding: "50px 40px",
        maxWidth: "520px",
        margin: "60px auto",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        borderRadius: "16px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif"
    };

    const labelStyle = {
        fontSize: "14px",
        fontWeight: 600,
        marginBottom: "6px",
        color: "#334155"
    };

    const inputStyle = {
        padding: "12px 14px",
        borderRadius: "10px",
        border: "1px solid #cbd5e1",
        fontSize: "15px",
        outline: "none"
    };

    if (submitted) {
        return (
        <div style={containerStyle}>
            <h2 style={{ marginBottom: "12px", color: "#0f172a" }}>
            Request Received
            </h2>
            <p style={{ color: "#475569", lineHeight: 1.6 }}>
            Your request for access has been received. You will receive an email
            from your organization admin to complete your registration. If you do
            not receive the email, please contact your organization admin.
            </p>
        </div>
        );
    }

    return (
        <div style={containerStyle}>
        {/* Image placeholder */}
        <div style={{ textAlign: "center", marginBottom: "0px" }}>
            <img
                src="/cloudgenomics_black_medium.png"
                alt="CloudGenomics"
                style={{ width: "150px", margin: "0px 0" }}
            />
        </div>

        <h2 style={{ textAlign: "center", marginBottom: "8px", color: "#0f172a" }}>
            Request Access
        </h2>
        <p style={{ textAlign: "center", color: "#64748b", marginBottom: "30px" }}>
            Submit your details to get started with CloudGenomics
        </p>

        {error && (
            <p style={{ color: "#dc2626", marginBottom: "20px", textAlign: "center" }}>
            {error}
            </p>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>First Name</label>
            <input name="firstName" value={form.firstName} onChange={handleChange} style={inputStyle} required />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>Last Name</label>
            <input name="lastName" value={form.lastName} onChange={handleChange} style={inputStyle} required />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>Email Address</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} style={inputStyle} required />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>Phone Number</label>
            <input name="phone" value={form.phone} onChange={handleChange} style={inputStyle} required />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>Organization Admin Email<br/>(This must be already registered email address of your organization's admin user on CloudGenomics)</label>
            <input
                type="email"
                name="orgAdminEmail"
                value={form.orgAdminEmail}
                onChange={handleChange}
                style={inputStyle}
                required
            />
            </div>

            <button
            type="submit"
            style={{
                marginTop: "10px",
                padding: "14px",
                borderRadius: "6px",
                border: "none",
                fontSize: "16px",
                fontWeight: 600,
                background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                color: "#fff",
                cursor: "pointer",
                boxShadow: "0 8px 20px rgba(37,99,235,0.35)"
            }}
            >
            Submit Request
            </button>

            <Link
                to="/login"
                    style={{
                        display: "inline-block",
                        padding: "12px 24px",
                        fontSize: "16px",
                        textAlign: "center",
                        backgroundColor: "#28a745",
                        color: "white",
                        borderRadius: "6px",
                        textDecoration: "none",
                        //width: "250px"
                    }}
                >
                Sign In
            </Link>
        </form>
        </div>
    );
};

export default RequestAccess;
